@if (user()) {
<div class="flex flex-col items-center m-4">

  <p-card class="flex m-4 p-4 w-max">

    <!-- Card Header -->
    <ng-template pTemplate="title">
      <h1 class="text-center mt-2">
        {{ (user()?.profile?.firstName || firstNameFromClaim()) + ' ' + (user()?.profile?.lastName || lastNameFromClaim()) }}
      </h1>
      <hr class="my-4" />
    </ng-template>

    <!-- Card Content -->
    <div class="space-y-6 p-4">

      <!-- Update Password Button -->
      @if (!isEntraIdUser()) {
        <button class="text-blue-400 hover:text-blue-800 font-medium underline cursor-pointer" type="button"
          (click)="onSetUserPassword()">
          Update Password
        </button>
      }

      <!-- User Details -->
      <dl class="grid grid-cols-2 gap-y-2 gap-x-2">
        <dt class="font-medium text-right">Company:</dt>
        <dd>{{ user()?.profile?.organization || organizationFromClaim() }}</dd>

        <dt class="font-medium text-right">Auth Source:</dt>
        <dd>{{ isEntraIdUser() ? 'Entra-ID' : 'Database' }}</dd>

        @if (!isEntraIdUser()) {
          <dt class="font-medium text-right">Job Title:</dt>
          <dd>{{ user()?.profile?.jobTitle }}</dd>
        }

        <dt class="font-medium text-right">Database:</dt>
        <dd>{{ user()?.profile?.database?.slice(0, -2) }}</dd>

        <dt class="font-medium text-right">Email:</dt>
        <dd>{{ user()?.profile?.email || emailFromClaim() }}</dd>

        <dt class="font-medium text-right">Auth-ID:</dt>
        <dd>{{ user()?.authId.replace('auth0|', '') }}</dd>

        <dt class="font-medium text-right">Licensed:</dt>
        <dd>{{ user()?.isLicensed }}</dd>

        <!-- Show highest role for Entra-ID users -->
        @if (isEntraIdUser()) {
          <dt class="font-medium text-right">Role:</dt>
          <dd>{{ highestRoleFromClaim() }}</dd>
        }

        <!-- Show individual roles for database users -->
        @if (!isEntraIdUser()) {
          <dt class="font-medium text-right">Global Admin:</dt>
          <dd>{{ user()?.profile?.isGlobalAdmin ?? false }}</dd>

          <dt class="font-medium text-right">Admin:</dt>
          <dd>{{ user()?.roles?.admin ?? false }}</dd>

          <dt class="font-medium text-right">Read-Only:</dt>
          <dd>{{ user()?.roles.readOnly }}</dd>

          <dt class="font-medium text-right">Catalog Admin:</dt>
          <dd>{{ user()?.roles.catalogAdmin }}</dd>
        }
      </dl>
    </div>
  </p-card>
</div>
}